module.exports = __webpack_public_path__ + "img/imagen_lado_derecho_contacto.ad215d27.png";